// extracted by mini-css-extract-plugin
export default {"image":"WY-z","loaded":"XY-z"};